import { monthSelector } from 'selectors'
import { setGetParams } from 'actions/navigation'
import {
  clearCalendar,
  fetchCalendar
} from 'actions/calendar'
import { deselectCalendarDay } from 'actions/calendar_day'
import { isDiagnosticsEnabledSelector } from 'selectors/diagnostics'

const saveDiagnosticsEnabledState = (diagnosticsEnabled) => ({
  type: 'SET_DIAGNOSTICS_ENABLED',
  payload: {
    enabled: diagnosticsEnabled
  }
})

export const setDiagnosticsEnabled = (enabledState) => (dispatch, getState) => {
  const state = getState()
  if (isDiagnosticsEnabledSelector(state) === enabledState) return

  dispatch(setGetParams({ diagnostics: enabledState ? 1 : null }))
  dispatch(saveDiagnosticsEnabledState(enabledState))
  dispatch(deselectCalendarDay())
  dispatch(clearCalendar())
  dispatch(fetchCalendar(monthSelector(state)))
}
